import {Form, FormFieldValidationResult, IFormData} from '@mintdata-wsp/common/components/form/Form';
import {ErrorPopupSide, IFormFieldState} from '@mintdata-wsp/common/components/formField/FormField';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Input, InputSize} from '@mintdata-wsp/common/components/input/Input';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import bind from 'bind-decorator';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/dialogs/publish/ConnectDomainFirstStep.less');

export interface IConnectDomainFirstStepProps
{
}

@observer
export class ConnectDomainFirstStep extends BaseComponentWithContext<IConnectDomainFirstStepProps>
{
    private _form:Form = new Form({
        onSubmit: this._onDomainSubmit
    });

    @bind
    private _onDomainSubmit(formData:IFormData):void
    {
        controllers.ui.publish.nextConnectDomainDialogStep();
    }

    @bind
    private _validateDomain(newValue:string, state:IFormFieldState<string>):FormFieldValidationResult
    {
        return controllers.ui.publish.validateDomain(newValue, state);
    }

    @bind
    private _onDomainChange(newValue:string):void
    {
        controllers.ui.publish.setCnameHostname(newValue);
    }

    public render():JSX.Element
    {
        const {cnameHostname} = rootState.ui.publish;

        return <Column>
            <div className={styles.addDomainNote}>
                <div>
                    Enter the exact domain name you want peaople to see when they visit your site.
                </div>
                <div>
                    It can be a domain (<b>yourdomain.com</b>) or a subdomain (<b>app.yourdomain.com</b>).
                </div>
            </div>
            <Input
                form={this._form}
                formKey={'domain'}
                placeholder="Domain"
                initialValue={cnameHostname}
                icon={MDIcons.common.World}
                validationFn={this._validateDomain}
                errorPopupSide={ErrorPopupSide.Bottom}
                size={InputSize.ExtraLarge}
                onChange={this._onDomainChange}
                isInitiallyFocused={true}
            />
        </Column>;
    }
}
